// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"dfe5ba80","441":"d2ae65f4","514":"cca8c9be","652":"9a79cfd4"}[chunkId] + ".chunk.js";
};